import styled from 'styled-components';

export const StyledTimeRow = styled.div`
   display: flex;
   gap: 10px;
   align-items: center;
`;
StyledTimeRow.displayName = 'StyledTimeRow';
